import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { AppState } from 'src/app/app.reducer';
import { RecipientZelleService } from '../../services/recipient-zelle.service';
import { BeneficiarioZelle } from '../../interfaces/beneficiario-zelle.interface';
import { AddBeneficiaryZelleComponent } from './components/add-beneficiary-zelle/add-beneficiary-zelle.component';

@Component({
  selector: 'app-recipient-zelle',
  templateUrl: './recipient-zelle.component.html',
  styleUrls: ['./recipient-zelle.component.sass']
})

export class RecipientZelleComponent  implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  usuarioID: number | undefined;
  listaCuentas: BeneficiarioZelle[] = [];
  @Input() seleccionable = false;
  @Output() seleccion: EventEmitter<BeneficiarioZelle> = new EventEmitter();
  constructor(
    private store: Store<AppState>,
    private accountRecipientService: RecipientZelleService,
    private dialog: MatDialog
  ) {
    this.initFormCuenta();
  }



  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  initFormCuenta() {
    this.subscriptions.add(
      this.store.select('auth').subscribe(async ({ user }) => {
        this.usuarioID = user?.usuarioId;
        if(this.usuarioID){
          this.listaCuentas = await this.accountRecipientService.getByUser(this.usuarioID);
        }
      })
    );

  }
  ngOnInit() {}

  async reloadAccount(){
    if(this.usuarioID){
      this.listaCuentas = await this.accountRecipientService.getByUser(this.usuarioID);
    }
  }

  openCreateDialog(cuenta?: BeneficiarioZelle):void{
    const isMobile = window.innerWidth < 768;
    const dialogData: any = {
      userID: this.usuarioID
    };
    if(cuenta){
      dialogData.type = 'UPDATE';
      dialogData.beneficiario = cuenta;
    }
    const dialogRef = this.dialog.open(AddBeneficiaryZelleComponent, {
      data: dialogData,
      disableClose: true,
      panelClass: 'aguacate-dialog',
      maxWidth: isMobile ? '95vw' : '560px',
      minWidth: isMobile ? '90vw' : '500px',
      maxHeight: '90vh',
    });
    dialogRef.afterClosed().subscribe(async result => {
      if(result == true && this.usuarioID){
        this.listaCuentas = await this.accountRecipientService.getByUser(this.usuarioID);
      }
    })
  }

  onSeleccion(cuenta:BeneficiarioZelle ){
    this.seleccion.emit(cuenta);
  }

}

